import toast from "react-hot-toast";
import { IoClose } from "react-icons/io5";
import i18n from "../../i18n";

/** Kapatma düğmeli, kalıcı olmayan uyarı bildirimi. */
export const customToast = (text) => {
  const toastId = toast(
    <div className="flex w-max max-w-[80vw] items-stretch gap-2">
      <div className="border-0 border-r-[1px] pr-2 py-4 border-solid border-stone-400 text-center">
        <p>{text}</p>
      </div>
      <button
        type="button"
        aria-label={i18n.t("common.close")}
        className="text-[1.7rem] text-red-500 px-1"
        onClick={() => toast.dismiss(toastId)}
      >
        <IoClose />
      </button>
    </div>,
    {
      position: "top-right",
      duration: 2000,
      style: {
        border: "1px solid #713200",
        padding: "0",
        maxWidth: "max-content",
      },
    }
  );
  return toastId;
};

export default customToast;
